class BackInStock extends HTMLElement {
    constructor() {
      super();
      this._form = null;
      this._onSubmitHandler = this.onSubmit.bind(this);
    }
  
    connectedCallback() {
      this.setupListeners();
    }
  
    setupListeners() {
      // Remove previous listeners if any
      if (this._form) {
        this._form.removeEventListener('submit', this._onSubmitHandler);
      }
  
      // Select the form inside the custom element
      this._form = this.querySelector('form');
      if (this._form) {
        this._form.addEventListener('submit', this._onSubmitHandler);
      }
    }
  
    async onSubmit(e) {
      e.preventDefault();
  
      const submitButton = this._form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }
  
      try {
        const response = await this.subscribeToBIS();
  
        const messageDir = this.getAttribute('data-klaviyo-flow-branch') === 'lighting-notification'
          ? 'lightingNotification'
          : 'backInStock';
        const messages = window.theme.strings[messageDir] || {};
        const message = messages[response.ok ? 'success' : 'failure'] || 'An error occurred.';
        const cls = `prd-BackInStock_Message-${response.ok ? 'success' : 'error'}`;
  
        const messageEl = document.createElement('div');
        messageEl.className = `prd-BackInStock_Message ${cls}`;
        messageEl.innerHTML = message;
  
        this._form.style.display = 'none';
        this.appendChild(messageEl);
      } catch (error) {
        console.error('Failed to subscribe:', error);
  
        const errorMessage = 'There was a problem submitting your request.';
        const errorEl = document.createElement('div');
        errorEl.className = 'prd-BackInStock_Message prd-BackInStock_Message-error';
        errorEl.innerHTML = errorMessage;
  
        this._form.style.display = 'none';
        this.appendChild(errorEl);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    }
  
    async subscribeToBIS() {
      const inputEl = this._form.querySelector('[data-el="back-in-stock.input"]').value
      const variantEl = this._form.querySelector('[data-el="back-in-stock.sku"]').value

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": `${inputEl}`,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${variantEl}`
              }
            }
          }
        }
      }

      const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=JkKgYN';
  
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          revision: '2024-10-15',
          'content-type': 'application/json',
          Authorization: 'Klaviyo-API-Key pk_3ed6a2ecfcd0618d7774d52208bce50217'
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
  
      return response;
    }
  }
  
  customElements.define('back-in-stock', BackInStock);
  